(function () {
    'use strict';

    const $body = document.body;

    // Helper to access halo functions
    function getHalo() {
        return window.halo || {};
    }

    const menuMobile = {
        menuSidebarMobile: function () {
            var buttonIconOpen = document.querySelector('.mobileMenu-toggle');
            var buttonClose = document.querySelectorAll('.halo-sidebar-close');

            const menuSidebarMobileOpen = () => {
                const wasOpen = document.body.classList.contains('menu_open');

                requestAnimationFrame(() => {
                    document.body.classList.toggle('menu_open');
                    const isNowOpen = document.body.classList.contains('menu_open'); // Re-check after toggle

                    // Atualizar lazyLoad quando o menu for aberto
                    if (isNowOpen && !wasOpen && window.lazyLoadInstance) {
                        setTimeout(() => {
                            window.lazyLoadInstance.update();
                        }, 100);
                    }
                });

                const listMenuLoading = document.querySelectorAll('.list-menu-loading');
                listMenuLoading.forEach(el => el.remove());

                const navMobile = document.getElementById('navigation-mobile');
                if (!navMobile) {
                    return;
                }

                if (window.mobile_menu == 'default') {
                    const inlineMenu = navMobile.querySelector('.site-nav-mobile.nav .header__inline-menu');

                    if (!inlineMenu) {
                        // Mover o menu do header para o menu mobile (como no backup)
                        const headerInlineMenu = document.querySelector('.header .header__inline-menu, #HeaderNavigation [data-navigation]');

                        if (headerInlineMenu) {
                            const navMobileNav = navMobile.querySelector('.site-nav-mobile.nav');

                            if (navMobileNav) {
                                // Clonar o menu para não remover do header original
                                const navClone = headerInlineMenu.cloneNode(true);
                                navClone.className = 'header__inline-menu';
                                navMobileNav.appendChild(navClone);
                            }
                        }
                    }
                }


            };

            if (document.body.classList.contains('menu_open')) {
                menuSidebarMobileOpen();
            }

            if (buttonIconOpen) {
                buttonIconOpen.addEventListener('click', (event) => {
                    event.preventDefault();
                    menuSidebarMobileOpen();
                });
            }

            buttonClose.forEach(btn => {
                btn.addEventListener('click', () => {
                    $body.classList.remove('menu_open');
                });
            });


            // Redundant listeners removed. Logic handled by buttonClose or centralized handlers.

        },

        menuSidebarMobileToggle: function () {
            $body.addEventListener('click', function (e) {
                const menuLink = e.target.closest('.site-nav-mobile .list-menu .menu_mobile_link');
                if (!menuLink) return;

                if (!e.currentTarget.classList.contains('list-menu__item--end')) {
                    e.preventDefault();
                    e.stopPropagation();
                    var target = menuLink;
                    var parent = target.parentElement;
                    var menuDislosure1 = parent.querySelector('ul.list-menu--disclosure-1');

                    parent.classList.remove('is-hidden');
                    parent.classList.add('is-open');
                    parent.classList.remove('d-none');

                    if (menuDislosure1) {
                        const handleTransition = () => {
                            if (parent.classList.contains('is-open') && !parent.classList.contains('is-hidden') && !parent.classList.contains('d-none')) {
                                Array.from(parent.parentElement.children).forEach(sibling => {
                                    if (sibling !== parent) {
                                        sibling.classList.remove('is-open');
                                        sibling.classList.add('is-hidden');
                                        sibling.classList.remove('d-none');
                                    }
                                });
                            }
                            menuDislosure1.removeEventListener('transitionend', handleTransition);
                        };
                        menuDislosure1.addEventListener('transitionend', handleTransition, { once: true });
                    }
                }
            });

            $body.addEventListener('click', function (e) {
                const menuLink2 = e.target.closest('.site-nav-mobile .list-menu .menu_mobile_link_2');
                if (!menuLink2) return;

                e.preventDefault();
                e.stopPropagation();
                var target = menuLink2;
                var parent = target.parentElement?.parentElement;
                var menuDislosure2 = target.parentElement?.querySelector('ul.list-menu--disclosure-2');
                var parentToScroll = target.parentElement?.parentElement?.parentElement?.parentElement?.parentElement?.parentElement;

                if (parent) {
                    parent.classList.remove('is-hidden');
                    parent.classList.add('is-open');
                    parent.classList.remove('d-none');
                }

                if (menuDislosure2) {
                    const handleTransition = () => {
                        if (parent && parent.classList.contains('is-open') && !parent.classList.contains('is-hidden') && !parent.classList.contains('d-none')) {
                            parent.classList.add('d-none');
                            Array.from(parent.parentElement.children).forEach(sibling => {
                                if (sibling !== parent) {
                                    sibling.classList.remove('is-open');
                                    sibling.classList.add('is-hidden');
                                    sibling.classList.remove('d-none');
                                }
                            });
                            if (parentToScroll) {
                                parentToScroll.scrollTop = 0;
                            }
                        }
                        menuDislosure2.removeEventListener('transitionend', handleTransition);
                    };
                    menuDislosure2.addEventListener('transitionend', handleTransition, { once: true });
                }

                const menuDropdown = target.closest('.menu-dropdown');
                if (menuDropdown) {
                    const hasMegamenuStyle = ['megamenu_style_5', 'megamenu_style_4', 'megamenu_style_3', 'megamenu_style_2', 'megamenu_style_1'].some(style => menuDropdown.classList.contains(style));
                    if (hasMegamenuStyle) {
                        menuDropdown.scrollTop = 0;
                    }
                    menuDropdown.classList.add('is-overflow');
                }
            });

            $body.addEventListener('click', function (e) {
                const navTitle = e.target.closest('.nav-title-mobile');
                if (!navTitle) return;

                e.preventDefault();
                e.stopPropagation();
                var target = navTitle;
                var parentLv1 = target.parentElement?.parentElement?.parentElement?.parentElement;
                var parentLv2 = target.parentElement?.parentElement?.parentElement;
                var parentLv3 = target.parentElement?.parentElement;

                // Find elements with .is-open class
                const findOpenParent = (el) => {
                    while (el && !el.classList.contains('is-open')) {
                        el = el.parentElement;
                    }
                    return el;
                };

                const openLv1 = findOpenParent(parentLv1);
                const openLv2 = findOpenParent(parentLv2);
                const openLv3 = findOpenParent(parentLv3);

                if (openLv1) {
                    Array.from(openLv1.parentElement.children).forEach(sibling => {
                        if (sibling !== openLv1) sibling.classList.remove('is-hidden');
                    });
                    openLv1.classList.remove('is-open', 'd-none');
                }
                if (openLv2) {
                    Array.from(openLv2.parentElement.children).forEach(sibling => {
                        if (sibling !== openLv2) sibling.classList.remove('is-hidden');
                    });
                    openLv2.classList.remove('is-open', 'd-none');
                }
                if (openLv3) {
                    Array.from(openLv3.parentElement.children).forEach(sibling => {
                        if (sibling !== openLv3) sibling.classList.remove('is-hidden');
                    });
                    openLv3.classList.remove('is-open', 'd-none');
                }

                document.querySelectorAll('.menu-dropdown').forEach(dropdown => {
                    dropdown.classList.remove('is-overflow');
                });
            });

            if (window.mobile_menu != 'default') {
                document.addEventListener('click', function (event) {
                    const tabButton = event.target.closest('[data-mobile-menu-tab]');
                    if (!tabButton) return;

                    event.preventDefault();
                    event.stopPropagation();

                    var tabItem = tabButton.closest('li');
                    if (!tabItem) return;

                    var tabTarget = tabButton.getAttribute('data-target');

                    if (!tabItem.classList.contains('is-active')) {
                        const navTabMobile = document.querySelector('[data-navigation-tab-mobile]');
                        if (navTabMobile) {
                            navTabMobile.querySelectorAll('li').forEach((element) => {
                                if (element != tabItem) {
                                    element.classList.remove('is-active');
                                } else {
                                    element.classList.add('is-active');

                                    document.querySelectorAll('[id^="MenuMobileListSection-"]').forEach((tab) => {
                                        if (tab.getAttribute('id') == tabTarget) {
                                            tab.classList.remove('is-hidden');
                                            tab.classList.add('is-visible');
                                        } else {
                                            tab.classList.remove('is-visible');
                                            tab.classList.add('is-hidden');
                                        }
                                    });
                                }
                            });
                        }
                    }
                });
            }

            document.querySelectorAll('[data-navigation-mobile] .no-megamenu .menu-lv-1__action').forEach(link => {
                link.addEventListener('click', (event) => {
                    const href = event.currentTarget.getAttribute('href');
                    if (!href) return;
                    const hash = href.split('#')[1];

                    if (hash != undefined && hash != '' && document.getElementById(hash)) {
                        document.body.classList.remove('menu_open');
                        const targetElement = document.getElementById(hash);
                        if (targetElement) {
                            const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
                            window.scrollTo({
                                top: targetPosition,
                                behavior: 'smooth'
                            });
                        }
                    }
                });
            });
        },

        initMultiTab: function () {
            let designMode, showMenu, check = true;
            document.body.matches('.shopify-design-mode') ? designMode = true : designMode = false;
            document.body.matches('.menu_open') ? showMenu = true : showMenu = false;

            const halo = getHalo();
            const loadMenuDefault = () => {
                if (check) {
                    check = false;
                    if (halo.initMobileMenuDefault) {
                        halo.initMobileMenuDefault(url);
                    }
                }
            }

            const loadMenuTab = () => {
                if (check) {
                    check = false;
                    if (halo.initMultiTabMobile) {
                        halo.initMultiTabMobile();
                    }
                }
            }

            const menuTabElement = document.querySelector('[data-menu-tab]');
            if (menuTabElement) {
                const activeLi = menuTabElement.querySelector('li.is-active');
                const active = activeLi ? (activeLi.dataset.loadPage || activeLi.getAttribute('data-load-page')) : null;
                var url = window.routes.root + `/search?type=product&q=${active}&view=ajax_mega_menu`;

                if ($body.classList.contains('template-index')) {
                    if (window.innerWidth < 1025) {
                        if (window.mobile_menu == 'default') {
                            window.addEventListener('load', () => {
                                if (designMode || showMenu) {
                                    loadMenuDefault();
                                }
                                else {
                                    document.body.addEventListener('click', () => {
                                        loadMenuDefault();
                                    }, false)
                                }
                            }, false)
                        } else {
                            window.addEventListener('load', () => {
                                if (designMode || showMenu) {
                                    loadMenuTab();
                                }
                                else {
                                    document.body.addEventListener('click', () => {
                                        loadMenuTab();
                                    }, false)
                                }
                            }, false)
                        }
                    }
                } else {
                    if (window.innerWidth < 1025) {
                        if (window.mobile_menu == 'default') {
                            window.addEventListener('load', () => {
                                if (designMode || showMenu) {
                                    loadMenuDefault();
                                }
                                else {
                                    document.body.addEventListener('click', () => {
                                        loadMenuDefault();
                                    }, false)
                                }
                            }, false)
                        } else {
                            window.addEventListener('load', () => {
                                if (designMode || showMenu) {
                                    loadMenuTab();
                                }
                                else {
                                    document.body.addEventListener('click', () => {
                                        loadMenuTab();
                                    }, false)
                                }
                            }, false)
                        }
                    }
                }
            } else {
                var url = window.routes.root + '/search?view=ajax_mega_menu';

                if (window.innerWidth < 1025) {
                    if (window.mobile_menu == "default") {
                        if (designMode || showMenu) {
                            loadMenuDefault();
                        }
                        else {
                            document.body.addEventListener("click", () => {
                                loadMenuDefault();
                            }, false)
                        }
                    } else {
                        window.addEventListener("load", () => {
                            if (designMode || showMenu) {
                                loadMenuTab();
                            }
                            else {
                                document.body.addEventListener("click", () => {
                                    loadMenuTab();
                                }, false)
                            }
                        }, false)
                    }
                }
            }
        },

        initMobileMenuDefault: function (url) {
            const menuMobile = document.querySelector('[data-navigation-mobile]');
            const nav = document.querySelector('#HeaderNavigation [data-navigation]');
            if (!menuMobile || !nav) return;

            const headerNav = nav.closest('#HeaderNavigation');
            const style = nav.getAttribute('style') || (headerNav ? headerNav.getAttribute('style') : '');
            document.querySelectorAll('.list-menu-loading').forEach(el => el.remove());

            if (menuMobile.querySelector('.header__inline-menu')) return;

            const navClone = nav.cloneNode(true);
            navClone.className = 'header__inline-menu';
            navClone.setAttribute('data-navigation', '');
            navClone.setAttribute('role', 'navigation');
            if (style) navClone.setAttribute('style', style);
            menuMobile.appendChild(navClone);

            const topLanCur = document.querySelector('.top-language-currency');
            const lanCurMobile = document.querySelector('#navigation-mobile .nav-currency-language');
            if (lanCurMobile && topLanCur) {
                if (lanCurMobile.textContent.trim() == '') {
                    const div = document.createElement('div');
                    div.className = 'top-language-currency';
                    div.innerHTML = topLanCur.innerHTML;
                    lanCurMobile.appendChild(div);
                }
            }

            // Menu Mobile Tab on Header Vertical
            const menuVertical = document.querySelector('.header-nav-vertical-menu .vertical-menu .header__menu-vertical')
            if (menuVertical) {
                document.querySelector('.halo-sidebar.halo-sidebar_menu').classList.add('has-menu-vertical')

                const menuVerticalTitle = document.querySelector('.header-nav-vertical-menu .vertical-menu .categories-title__button .title').innerHTML
                const navMobile = document.querySelector('.site-nav-mobile.nav')
                const navMobileTitle = navMobile.querySelector('.menu-heading-mobile')
                const span = document.createElement('span')
                span.classList.add('title')
                span.innerHTML = menuVerticalTitle;
                navMobileTitle.appendChild(span);
                navMobile.appendChild(menuVertical);

                const menuVerticalNav = document.querySelector('.site-nav-mobile.nav .header__menu-vertical')
                menuVerticalNav.classList.add('header__inline-menu')

                const tabTitle = document.querySelectorAll('.site-nav-mobile.nav .menu-heading-mobile .title')
                const mobileMenu = document.querySelectorAll('.site-nav-mobile.nav .header__inline-menu')
                tabTitle[0].classList.add('is-active')
                mobileMenu[0].classList.add('is-active')

                tabTitle.forEach((item, index) => {
                    item.addEventListener('click', () => {
                        tabTitle.forEach(e => e.classList.remove('is-active'))
                        item.classList.add('is-active')
                        mobileMenu.forEach(e => e.classList.remove('is-active'))
                        mobileMenu[index].classList.add('is-active')
                    })
                })
            }

            if (window.innerWidth < 1025) {
                const menuItemsMega = document.querySelectorAll('.menu-lv-item.has-megamenu');
                const halo = getHalo();

                if (menuItemsMega.length > 0) {
                    menuItemsMega.forEach(menuItem => {
                        menuItem.addEventListener('click', function (e) {
                            const block = this.querySelector('.menu-dropdown__block--content .products-carousel');
                            if (!block) return;

                            const handle = block.dataset.product || block.getAttribute('data-product');
                            const url = block.dataset.collection || block.getAttribute('data-collection');
                            var url_handle;

                            if (block.classList.contains('megamenu_1')) {
                                if (handle) {
                                    url_handle = window.routes.root + '/products/' + handle;
                                }
                            } else if (block.classList.contains('megamenu_5')) {
                                if (url) {
                                    url_handle = window.routes.root + '/collections/' + url;
                                }
                            }

                            if (url_handle && halo.renderMegaMenuProductBlock) {
                                halo.renderMegaMenuProductBlock(block, url_handle);
                            }
                        });
                    });
                }
            }
        },

        initMultiTabMobile: function () {
            if (window.innerWidth < 1025) {
                if (window.mobile_menu == 'custom') {
                    var chk = true,
                        menuElement = document.querySelectorAll('[data-section-type="menu"]'),
                        menuMobile = document.querySelector('[data-navigation-mobile]'),
                        menuTabMobile = document.querySelector('[data-navigation-tab-mobile]');

                    const loadMenu = () => {
                        if (chk) {
                            chk = false;
                            const content = document.createElement('div');
                            const tab = document.createElement('ul');

                            Object.assign(tab, {
                                className: 'menu-tab list-unstyled'
                            });

                            tab.setAttribute('role', 'menu');

                            menuElement.forEach((element, index) => {
                                var currentMenu = element.querySelector('template').content.firstElementChild.cloneNode(true);

                                if (index == 0) {
                                    currentMenu.classList.add('is-visible');
                                } else {
                                    currentMenu.classList.add('is-hidden');
                                }

                                content.appendChild(currentMenu);
                            });

                            content.querySelectorAll('[id^="MenuMobileListSection-"]').forEach((element, index) => {
                                var tabTitle = element.dataset.heading,
                                    tabId = element.getAttribute('id'),
                                    tabElement = document.createElement('li');

                                Object.assign(tabElement, {
                                    className: 'item'
                                });

                                tabElement.setAttribute('role', 'menuitem');

                                if (index == 0) {
                                    tabElement.classList.add('is-active');
                                }

                                tabElement.innerHTML = `<a role="link" aria-disabled="true" class="link" data-mobile-menu-tab data-target="${tabId}">${tabTitle}</a>`;

                                tab.appendChild(tabElement);
                            });

                            document.querySelectorAll('.list-menu-loading').forEach(el => el.remove());
                            if (menuTabMobile) menuTabMobile.innerHTML = tab.outerHTML;
                            if (menuMobile) menuMobile.innerHTML = content.innerHTML;
                        }

                    }

                    if (document.querySelector('.header-nav-plain .header-language_currency')) {
                        const topLanCur = document.querySelector('.top-language-currency');
                        const lanCurMobile = document.querySelector('#navigation-mobile .nav-currency-language');
                        if (lanCurMobile && topLanCur && lanCurMobile.textContent.trim() == '') {
                            const div = document.createElement('div');
                            div.className = 'top-language-currency';
                            div.innerHTML = topLanCur.innerHTML;
                            lanCurMobile.appendChild(div);
                        }
                    }

                    if (document.body.matches('.menu_open')) {
                        loadMenu();
                    }

                    document.body.addEventListener('click', () => {
                        loadMenu();
                    });
                }
            }

            if (window.innerWidth < 1025) {
                const menuItemsMega = document.querySelectorAll('.menu-lv-item.has-megamenu');
                const halo = getHalo();

                if (menuItemsMega.length > 0) {
                    menuItemsMega.forEach(menuItem => {
                        menuItem.addEventListener('click', function (e) {
                            const block = this.querySelector('.menu-dropdown__block--content .products-carousel');
                            if (!block) return;

                            const handle = block.dataset.product || block.getAttribute('data-product');
                            const url = block.dataset.collection || block.getAttribute('data-collection');
                            var url_handle;

                            if (block.classList.contains('megamenu_1')) {
                                if (handle) {
                                    url_handle = window.routes.root + '/products/' + handle;
                                }
                            } else if (block.classList.contains('megamenu_5')) {
                                if (url) {
                                    url_handle = window.routes.root + '/collections/' + url;
                                }
                            }

                            if (url_handle && halo.renderMegaMenuProductBlock) {
                                halo.renderMegaMenuProductBlock(block, url_handle);
                            }
                        });
                    });
                }
            }
        }
    };

    // Attach to window.halo
    if (!window.halo) {
        window.halo = {};
    }

    // Attach all menu mobile functions to halo
    Object.assign(window.halo, menuMobile);

    // Auto-initialize on mobile
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            if (window.innerWidth < 1025) {
                menuMobile.menuSidebarMobile();
                menuMobile.menuSidebarMobileToggle();
            }
            menuMobile.initMultiTab();
            menuMobile.initMultiTabMobile();
        });
    } else {
        if (window.innerWidth < 1025) {
            menuMobile.menuSidebarMobile();
            menuMobile.menuSidebarMobileToggle();
        }
        menuMobile.initMultiTab();
        menuMobile.initMultiTabMobile();
    }
})();

